import { useAuthApi, useCloudApi } from '@/api/cloudApi'
import type { V1alpha1RoleBinding } from '@streamnative/cloud-api-client-typescript'

export const fetchSelfSubjectRbacReview = (namespace: string) => {
  try {
    const api = useAuthApi()
    return api.createSelfSubjectRbacReview({ spec: { namespace } })
  } catch (e) {
    throw getErrorMessage(e, 'fetch SelfSubjectRbacReview Error')
  }
}

export const fetchRolebindings = (namespace: string) => {
  try {
    const api = useCloudApi()
    return api.listNamespacedRoleBinding(namespace)
  } catch (e) {
    throw getErrorMessage(e, 'fetch Rolebindings Error')
  }
}

export const fetchRoles = (namespace: string) => {
  try {
    const api = useCloudApi()
    return api.listNamespacedRole(namespace)
  } catch (e) {
    throw getErrorMessage(e, 'fetch Roles Error')
  }
}

export const createRolebinding = (namespace: string, rolebinding: V1alpha1RoleBinding) => {
  try {
    const api = useCloudApi()
    return api.createNamespacedRoleBinding(namespace, rolebinding)
  } catch (e) {
    throw getErrorMessage(e, 'create Rolebinding Error')
  }
}

export const deleteRolebinding = (name: string, namespace: string) => {
  try {
    const api = useCloudApi()
    return api.deleteNamespacedRoleBinding(name, namespace)
  } catch (e) {
    throw getErrorMessage(e, 'delete Rolebinding Error')
  }
}
